import { TypedDocumentNode, gql } from '@apollo/client';
import styled, { css } from 'styled-components';

import { Horizontal } from 'atoms/layout/flex';
import { groupBy, sortByArrayIndex } from 'lib/arrays';

import { ActualReward } from './ActualReward';
import { ActualRewards_so5Reward } from './__generated__/index.graphql';

const RewardsList = styled.div`
  display: inline-flex;
  gap: var(--unit);
`;
const RewardsContainer = styled(Horizontal)<{ $wrap?: boolean }>`
  ${({ $wrap = false }) =>
    $wrap
      ? css`
          flex-wrap: wrap;
        `
      : css`
          white-space: nowrap;
        `}
`;

const REWARD_TYPE_ORDER = ['card', 'fiat', 'coin'];

const getRewardType = (reward: ActualRewards_so5Reward) => {
  if (reward?.rewardCards.length > 0) {
    return 'card';
  }
  if (reward?.amount?.usd) {
    return 'fiat';
  }
  if (reward.coinAmount) {
    return 'coin';
  }
  if (reward?.probabilisticBundle) {
    return 'probabilisticBundle';
  }
  return 'unknown';
};

const sortByRewardType = (rewards: ActualRewards_so5Reward[]) => {
  return [...rewards].sort((a, b) =>
    sortByArrayIndex(REWARD_TYPE_ORDER, getRewardType(a), getRewardType(b))
  );
};
type Props = {
  rewards: ActualRewards_so5Reward[];
  wrap?: boolean;
  withoutLink?: boolean;
};
const ActualRewards = ({ rewards, wrap, withoutLink }: Props) => {
  const groupedRewards = groupBy(sortByRewardType(rewards), getRewardType);
  return (
    <RewardsList>
      {rewards.length > 0 && (
        <RewardsContainer $wrap={wrap}>
          {Object.values(groupedRewards)?.map(r => {
            if (r?.length > 0 && r[0])
              return (
                <ActualReward
                  key={r[0].slug}
                  reward={r[0]}
                  count={r.length}
                  withoutLink={withoutLink}
                />
              );
            return null;
          })}
        </RewardsContainer>
      )}
    </RewardsList>
  );
};

ActualRewards.fragments = {
  so5Reward: gql`
    fragment ActualRewards_so5Reward on So5Reward {
      slug
      ...ActualReward_so5Reward
    }
    ${ActualReward.fragments.so5Reward}
  ` as TypedDocumentNode<ActualRewards_so5Reward>,
};

export default ActualRewards;
